import React, { useState, useCallback } from 'react';
import { createPortal } from 'react-dom';
import Cropper from 'react-easy-crop';
import styles from './ImageCropModal.module.css';
import getCroppedImg from './cropImage';

const ImageCropModal = ({ imageSrc, onCancel, onConfirm }) => {
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    const showCroppedImage = useCallback(async () => {
        try {
            const croppedImageBlob = await getCroppedImg(
                imageSrc,
                croppedAreaPixels
            );
            onConfirm(croppedImageBlob);
        } catch (e) {
            console.error(e);
            onCancel();
        }
    }, [imageSrc, croppedAreaPixels, onConfirm, onCancel]);

    const modalContent = (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
                <div className={styles.cropperContainer}>
                    <Cropper
                        image={imageSrc}
                        crop={crop}
                        zoom={zoom}
                        aspect={1}
                        onCropChange={setCrop}
                        onCropComplete={onCropComplete}
                        onZoomChange={setZoom}
                    />
                </div>

                <div className={styles.zoomControl}>
                    <span className={styles.zoomLabel}>확대/축소</span>
                    <input
                        type="range"
                        value={zoom}
                        min={1}
                        max={3}
                        step={0.1}
                        aria-labelledby="Zoom"
                        onChange={(e) => setZoom(e.target.value)}
                        className={styles.slider}
                    />
                </div>

                <div className={styles.controls}>
                    <button
                        className={`${styles.button} ${styles.cancelButton}`}
                        onClick={onCancel}
                    >
                        취소
                    </button>
                    <button
                        className={`${styles.button} ${styles.confirmButton}`}
                        onClick={showCroppedImage}
                    >
                        확인
                    </button>
                </div>
            </div>
        </div>
    );

    return createPortal(modalContent, document.body);
};

export default ImageCropModal;
